import { useMemo } from "react"


const useTestTakersTableColumns = () => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'test_taker_name',
                header: "שם התלמיד"
            }
        ], []
    )

    return columns
}

export default useTestTakersTableColumns